import { Breadcrumb, BreadcrumbIcon, BreadcrumbLink, BreadcrumbPage } from '@ads/components-react';
import { createFileRoute, Link, useNavigate } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';

import { SerieVideoLangForm } from '@/features/series-video-lang-management';
import { PageHeader } from '@/shared/ui/organisms/PageHeader';

export const Route = createFileRoute(
  '/_authenticated/series/$serieId/videos/$videoId/langs/create/',
)({
  component: SerieVideoLangCreatePage,
});

/** Página de criação de Idioma do Vídeo. */
export function SerieVideoLangCreatePage() {
  const { t } = useTranslation('series');
  const { serieId: serieIdParam, videoId: videoIdParam } = Route.useParams();
  const videoId = Number(videoIdParam);
  const navigate = useNavigate();

  const goBack = () =>
    void navigate({
      to: '/series/$serieId/videos/$videoId/langs',
      params: { serieId: serieIdParam, videoId: videoIdParam },
    });

  return (
    <div className="flex flex-col gap-mini">
      <PageHeader
        title={t('videoLangs.form.createTitle')}
        breadcrumb={
          <Breadcrumb>
            <BreadcrumbLink>
              <Link to="/">
                <BreadcrumbIcon />
              </Link>
            </BreadcrumbLink>
            <BreadcrumbLink>
              <Link to="/series">{t('videoLangs.breadcrumb.series')}</Link>
            </BreadcrumbLink>
            <BreadcrumbLink>
              <Link to="/series/$serieId/videos" params={{ serieId: serieIdParam }}>
                {t('videoLangs.breadcrumb.videos')}
              </Link>
            </BreadcrumbLink>
            <BreadcrumbLink>
              <Link
                to="/series/$serieId/videos/$videoId/langs"
                params={{ serieId: serieIdParam, videoId: videoIdParam }}
              >
                {t('videoLangs.breadcrumb.langs')}
              </Link>
            </BreadcrumbLink>
            <BreadcrumbPage>{t('videoLangs.form.createTitle')}</BreadcrumbPage>
          </Breadcrumb>
        }
      />

      <SerieVideoLangForm videoId={videoId} lang={null} onSaved={goBack} onCancel={goBack} />
    </div>
  );
}
